import { request } from '@/utils/request';
import * as url from '@/src/constant';

const ROUTE_CERTIFICATE = '/pages/certificate/index';

// 获取证件详情
export function fetchCertInfo(query) {
  return request({
    url: url.QUERY_CERTIFICATE_INFO_URL,
    method: 'POST',
    query,
    returnUrl: ROUTE_CERTIFICATE,
  });
}

// 请求上传证件链接
export function fetchCertCheckUrl(query) {
  return request({
    url: url.QUERY_CERT_CHECK_URL,
    method: 'POST',
    query,
    returnUrl: ROUTE_CERTIFICATE,
  });
}
